import React from 'react';
import PropTypes from 'prop-types';

import isUndefined from 'lodash/isUndefined';
import isEqual from 'lodash/isEqual';

import { BB_BETCARD_CSS_ID_PREFIX, BB_BETCARD_CSS_CLASS_BLOCK_NAME } from './constants';

import './styles/bet-card-container.scss';

import MultiBetCard from './components/MultiBetCard';
import SingleBetCard from './components/SingleBetCard';
import BetCardFooter from './components/BetCardFooter';

export default class BetCardContainer extends React.Component {

    static propTypes = {
        betcard: PropTypes.object.isRequired,
        commonDataEvents: PropTypes.object.isRequired,
        cssIdPrefix: PropTypes.string.isRequired,
        errorHandler: PropTypes.func,
        gtmAttribute: PropTypes.string,
        sportName: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.element,
        ]),
        footerType: PropTypes.string,
    };

    static defaultProps = {
        gtmAttribute: '',
        footerType: null,
    };

    constructor(props) {
        super(props);
        this.state = { isError: false };
        this.errorHandler = this.errorHandler.bind(this);
    }

    errorHandler(err) {
        if (!isUndefined(this.props.errorHandler)) {
            this.props.errorHandler(err);
        }
        this.setState({ isError: true });
    }

    shouldComponentUpdate(nextProps, nextState) {
        return !isEqual(nextProps, this.props) || !isEqual(nextState, this.state);
    }

    getSelectionsData() {
        const selections = this.props.betcard.selection_pointers.map(selectionPointer => {
            const {event_id, market_id, selection_id} = selectionPointer;
            const event = this.props.commonDataEvents[event_id];

            if (isUndefined(event)) {
                return null;
            }

            const { sport_slug } = event;

            return {
                ...event.markets[market_id].selections[selection_id],
                sport_slug,
            };
        });

        return selections.filter(Boolean);
    }

    getBetcardCssId (betcardId) {
        return `${this.props.cssIdPrefix}_${BB_BETCARD_CSS_ID_PREFIX}-${betcardId}`;
    }

    render() {
        const betcardCssId = this.getBetcardCssId(this.props.betcard.betcard_id);
        const selections = this.getSelectionsData();
        const { gtmAttribute } = this.props;

        if (this.state.isError) {
            return null;
        }

        return (
                <div id={betcardCssId} className={BB_BETCARD_CSS_CLASS_BLOCK_NAME}>
                    {
                        this.props.betcard.bet_type !== 'Singles' ? (
                            <MultiBetCard
                                selections={selections}
                                betcard={this.props.betcard}
                                commonDataEvents={this.props.commonDataEvents}
                                gtmAttribute={gtmAttribute}
                            />
                        ) : (
                                <SingleBetCard
                                    betcard={this.props.betcard}
                                    selection={selections.shift()}
                                    commonDataEvents={this.props.commonDataEvents}
                                    errorHandler={this.errorHandler}
                                    gtmAttribute={gtmAttribute}
                                />
                        )
                    }
                   <BetCardFooter
                    betcard={this.props.betcard}
                    commonDataEvents={this.props.commonDataEvents}
                    sportName={this.props.sportName}
                    type={this.props.footerType}
                   />
                </div>
        );
    }
}
